// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1JLxY","text":"styles_text__2Z9lF"};